import { KeyframeConfig } from "../../../models/animations.model";

const A_NEW_PRODUCTION_TRANSLATE = 30;

export const getANewProductionInBaseKeyframe = (
  letterObjects: fabric.Object[],
  opacity: number,
  delay: number,
  duration: number
): KeyframeConfig[] => {
  return letterObjects.flatMap((letterObject: any, index: number) => {
    return [
      {
        option: {
          keyframes: [
            {
              opacity: 0,
              left: letterObject.left + A_NEW_PRODUCTION_TRANSLATE,
              duration: 1,
            },
            { opacity, left: letterObject.left, duration },
          ],
          targets: letterObject,
          delay: delay * (index + 1),
        },
      },
    ];
  });
};

export const getANewProductionOutBaseKeyframe = (
  letterObjects: fabric.Object[],
  opacity: number,
  delay: number,
  duration: number
): KeyframeConfig[] => {
  return letterObjects.flatMap((letterObject: any, index: number) => {
    return [
      {
        option: {
          keyframes: [
            {
              opacity,
              left: letterObject.left,
              duration: 1,
            },
            {
              opacity: 0,
              left: letterObject.left - A_NEW_PRODUCTION_TRANSLATE,
              duration,
            },
          ],
          targets: letterObject,
          delay: delay * (index + 1),
        },
      },
    ];
  });
};
